import { DropDown, Form, Modal } from '@finbeat/react-toolkit';
import { Prop } from 'models/api/prop';
import { Dispatch, SetStateAction, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import 'scss/Main.scss';
import ReportForm from './ReportForm';
import { useReportWorkplaceState } from './Reports';

export type ReportTypeForm = {
    id?: number;
    type: string;
    props: Prop[];
};

type ReportsChangeModalProps = {
    isOpen?: boolean;
    toggle: Dispatch<SetStateAction<boolean>>;
    reportTypes: DropDown[];
};

const ReportsChangeModal = ({ isOpen = false, toggle, reportTypes }: ReportsChangeModalProps) => {
    useTranslation();
    const { selectedItem, addItemMutation } = useReportWorkplaceState();
    const modalRef = useRef(null);

    const saveChanges = (data: ReportTypeForm) => {
        data.props.forEach((p) => {
            if (p.values) {
                // remove empty values
                p.values = p.values.filter((v) => v.value);
            }
        });

        addItemMutation.mutate({
            type: data.type,
            props: data.props.map((p) => {
                p.selectOptions = null;
                return p;
            }),
        });
        toggle(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={() => toggle(false)}
            scrollable
            className="reports__modal"
            innerRef={modalRef}
        >
            <Form<ReportTypeForm>
                onSubmit={(data) => saveChanges(data)}
                defaultValues={{
                    type: selectedItem
                        ? selectedItem.systemType
                        : reportTypes != null
                          ? (reportTypes[0]?.id?.toString() ?? '')
                          : '',
                    props: [],
                }}
                className="form-in-modal"
            >
                <ReportForm reportTypes={reportTypes} toggle={toggle} modalRef={modalRef} />
            </Form>
        </Modal>
    );
};

export default ReportsChangeModal;
